module.exports = __webpack_public_path__ + "img/device_point5-2.33c8ac62.png";